/**
 * Small Anton/letter-spaced kicker label used above headings
 * in the retro redesign (e.g. "OUR STORY", "2026-2027").
 */
import { Typography } from "@mui/material";

const EyebrowLabel = ({ children, color, sx }) => (
  <Typography
    component="span"
    sx={{
      display: "block",
      fontFamily: "Anton, sans-serif",
      fontSize: { xs: "12px", sm: "14px", md: "15px" },
      letterSpacing: "3px",
      textTransform: "uppercase",
      color,
      ...sx,
    }}
  >
    {children}
  </Typography>
);

export default EyebrowLabel;
